import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import {AbModalAttributes, IAbModalHeaderConfig} from "@/scripts/modules/ab-modal/ab-modal.types";
import {NAMES} from "@/scripts/modules/ab-modal/abModal.constants";

const buildInnerDom = (
  config: AbModalAttributes,
  modalContent: DocumentFragment
) => {
  const backDropClasses = `${NAMES.CLASSES.BACKDROP} ${config?.classesBackdrop ?? ''}`;
  const elBackdrop = createDomElementHandler("div", backDropClasses);

  const wrapperClasses = `${NAMES.CLASSES.WRAPPER} ${config?.classesWrapper ?? ''}`;
  const elWrapper = createDomElementHandler("div", wrapperClasses);

  const innerClasses = `${NAMES.CLASSES.INNER} ${config?.classesInner ?? ''}`;
  const elInner = createDomElementHandler("div", innerClasses);

  if(config.header?.show) {
    const elHeader = buildHeader(config.header);
    elWrapper.appendChild(elHeader);
  }

  elInner.appendChild(modalContent);
  elWrapper.appendChild(elInner);
  elBackdrop.appendChild(elWrapper);
  return elBackdrop;
}

const buildHeader = (
  headerConfig: IAbModalHeaderConfig
) => {
  const headerClasses = `${NAMES.CLASSES.HEADER} ${headerConfig?.classes ?? ''}`;
  const elHeader = createDomElementHandler("div", headerClasses);
  if (headerConfig?.text?.length) {
    const headerTitle = createDomElementHandler("h4", [NAMES.CLASSES.TITLE]);
    headerTitle.innerHTML = headerConfig.text;
    elHeader.appendChild(headerTitle)
  }
  if (headerConfig.closeButton) {
    const close = createDomElementHandler("button", [NAMES.CLASSES.CLOSE], {
      type: "button",
      "aria-label": headerConfig.closeButtonText || "Chiudi",
    });
    if (headerConfig?.closeButtonText) {
      const closeText = createDomElementHandler("span", [NAMES.CLASSES.CLOSE_TEXT]);
      closeText.innerText = headerConfig.closeButtonText;
      close.appendChild(closeText);
    }
    const closeIcon = createDomElementHandler("span", [NAMES.CLASSES.CLOSE_ICON], { "aria-hidden": "true" });
    close.appendChild(closeIcon);
    elHeader.appendChild(close);
  }
  return elHeader;
}


const parseConfig = (
  attributes: string | null): AbModalAttributes => {
  try {
    const config = JSON.parse(attributes);
    if (!config || typeof config !== 'object') {
      throw new Error("Config attribute is not a valid JSON object");
    }
    return config;
  } catch (e) {
    console.error("Cannot initialize modal due to bad config:", e);
  }
}

export default { buildInnerDom, parseConfig };